import React, { useEffect, useState } from "react";
import { ElfsightWidget } from "react-elfsight-widget";
import { Helmet } from "react-helmet-async";
import { Spinner } from "../../administration";
import Maps from "./Maps";
import ApiService from "../../service/ApiService";
import ReviewModel from "../../model/review";
import PageResultResponse from "../../model/page-result-response";
import useStyles from "./styles";
import Misc from "../../utils/Misc";

const ID = "2bec8895-4ccb-4030-a12b-6d21462f7759";

const Review = () => {
  const classes = useStyles();
  const [reviews, setReviews] = useState<ReviewModel[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  useEffect(() => {
    const fetchDate = async () => {
      setLoading(true);
      await ApiService.get<PageResultResponse>("frontend/reviews").then(
        (data: PageResultResponse) => {
          if (Misc.isArrayEmpty(data.items)) return;
          setReviews(data.items);
        }
      );
      setLoading(false);
    };

    if (Misc.isArrayEmpty(reviews)) fetchDate();
  }, [reviews]);

  return (
    <>
      <Helmet>
        <title>Reviews - Setup Remodeling</title>
        <meta
          name="description"
          content="Review our service. Setup Remodeling"
        ></meta>
        <link rel="canonical" href="/reviews" />
      </Helmet>
      <div className={classes.review}>
        {loading ? <Spinner /> : <Maps reviews={reviews} />}
        <div className={classes.reviewsList}>
          <ElfsightWidget widgetId={ID} />
        </div>
      </div>
    </>
  );
};

export default Review;
